// Grammaire des entrées de `FileTransfer_listFile.list_file` (module IRIS
// FileTransfer, bloc « Download specific files »).
//
// Deux formats coexistent :
// - **nouveau** (depuis le multi-files IRIS) : `n7` / `p10` — `n` = NAV,
//   `p` = PLD/SCI, suffixe = numéro de cycle. C'est déjà la notation de
//   `FileTransfer_state.gli_file_waiting` (cf docs/functional/websockets-wob-sample.md §9).
// - **legacy** : `nav|7` / `sci|10`. IRIS l'accepte encore mais le ré-écrit
//   au nouveau format, ce qui cassait la relecture côté front.
//
// On lit les deux, on écrit le nouveau.
//
// ⚠ La reconnaissance est STRICTE sur `\d+` : `list_file_nf` utilise une
// notation relative (`n-4:n-2`, `p-2`) avec les mêmes préfixes, qui ne doit
// jamais être confondue avec un numéro de cycle absolu.

export type ListFileKind = 'nav' | 'pld'

export interface ListFileEntry {
  kind: ListFileKind
  cycle: number
}

const LIST_FILE_RE = /^(?:(nav|sci)\|(\d+)|([np])(\d+))$/

/** Décode une entrée `list_file`. Retourne `null` si le format est inconnu. */
export function parseListFileEntry(entry: string): ListFileEntry | null {
  const m = LIST_FILE_RE.exec(String(entry).trim())
  if (!m) return null
  const kind: ListFileKind = m[1] ? (m[1] === 'nav' ? 'nav' : 'pld') : m[3] === 'n' ? 'nav' : 'pld'
  return { kind, cycle: parseInt(m[2] || m[4], 10) }
}

/** Encode une entrée `list_file` au format courant IRIS. */
export function formatListFileEntry(kind: ListFileKind, cycle: number): string {
  return `${kind === 'nav' ? 'n' : 'p'}${cycle}`
}

/**
 * IRIS dégrade un tableau à un seul élément en chaîne nue dans sa réponse
 * (`list_file_nf: 'n-2'` au lieu de `['n-2']`). Ré-enveloppe systématiquement :
 * un spread direct produirait les CARACTÈRES de la chaîne.
 */
export function ensureStringArray(value: Array<string> | string | null | undefined): Array<string> {
  if (value == null) return []
  if (Array.isArray(value)) return [...value]
  if (typeof value === 'string') return value.length > 0 ? [value] : []
  return []
}
